import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RecipeHandoffBaseEffect } from './recipe-handoff-base.effect';
import { recipeHandoffBaseReducer } from './recipe-handoff-base.reducer';
import { RECIPE_HANDOFF_BASE_PENDING_FEATURE_NAME } from './recipe-handoff-base.selector';

@NgModule({
  imports: [
    StoreModule.forFeature(RECIPE_HANDOFF_BASE_PENDING_FEATURE_NAME, recipeHandoffBaseReducer),
    EffectsModule.forFeature([ RecipeHandoffBaseEffect ])
  ]
})
export class RecipeHandoffBaseModule {}
